
const API_ENDPOINTS = {
    LOGIN: 'auth',
    SIGNUP: 'signup',
    RESET:'forgot',
    LOCATION:'locations',
    PROFITABILITY:'profitability',
    BANKROLL:'transactions',
    SELECTSCHEMA:'selectSchema',
    TIMEZONE: 'timezones',
    PROFILE: 'profile',
    SUPPORT: 'support',
    SESSIONS: 'sessions',
    LOCATIONS: 'locations',
    GAME_DETAILS: 'sessionDetails',
    SESSION_HAND:'sessionHands',
    SUBGAME:'subgame',
    PREFLOP:'preflopAction',
    FLOP:'flopAction',
    TURN:'turnAction',
    RIVER:'riverAction',
    SHOWDOWN:'showdown',
    AVILABELCARD:'availableCards',
    SHARE:'share'
  };
  
  export default API_ENDPOINTS;
  
